import { ValidationProvider, extend, setInteractionMode } from 'vee-validate';
import { required, email, numeric, confirmed, min, max } from 'vee-validate/dist/rules';


setInteractionMode('eager');

const zipRegex = /^[0-9]{3}-[0-9]{4}$/g;
const phoneRegex = /^(?:\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/g;
const desiredDateRegex = /\b([1-9]|[1][0-2])\b月\b([1-9]|[12][0-9]|3[01])\b日 (午前|午後)/;

extend('required', {
  ...required,
  message: '{_field_}を入力してください。',
});
extend('numeric', {
  ...numeric,
  message: '数字を入力してください。',
});
extend('min', {
  ...min,
  message: '{length}文字以上の{_field_}を入力して下さい。',
});
extend('max', {
  ...max,
  message: '{length}文字以下の{_field_}を入力して下さい。',
});
extend('email', {
  ...email,
  message: '正しい形式で入力してください。メールアドレスは、「mitsukaru@example.com」のような形式で入力してください。',
});
extend('zip', {
  validate: value => value.match(zipRegex),
  message: '正しい形式で入力ください。',
});
extend('phone', {
  validate: value => value.match(phoneRegex),
  message: '正しい形式で入力ください。',
});
extend('desiredDateValid', {
  validate: value => value.match(desiredDateRegex),
  message: '正しい形式で入力ください。',
});
extend('passwordIsNew', {
  params: ['target'],
  validate: (value, { target }) => {
    if (value === target) {
      return false;
    }
    return true;
  },
  message:
    '新しいパスワードは、現在のパスワードとは別である必要があります。',
});
extend('lessThan', {
  params: ['target'],
  validate: (value, { target }) => {
    if (+value >= +target) {
      return false;
    }
    return true;
  },
  message:
    '正しい値を入力して下さい。',
});
extend('confirmed', {
  ...confirmed,
  message:
    '新しく設定されたパスワードと一致したパスワードを入力してください。',
});

export default ValidationProvider;
